import { render, staticRenderFns } from "./shoppingCartItemsComponent.vue?vue&type=template&id=327a83ea"
import script from "./shoppingCartItemsComponent.vue?vue&type=script&lang=js"
export * from "./shoppingCartItemsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports